export default "__VITE_ASSET__BdYI4qQw__"